module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-45.6c723294.svg";